import { add, subtract, multiply, divide, round } from './calc';
import getHolidayAndCalendarInfo from './holiday';

// 定义方法中的名称在excel中的表头的名称  总薪资表
const totalSalaryMapping = {
    name: '姓名',
    department: '部门',
    salary: '应发工资',
    day: '实际出勤总天数'
};
// 定义方法中的名称在excel中的表头的名称  科研薪资表
const scientificSalaryMapping = {
    name: '项目人员',
    department: '部门',
    salary: '项目应发工资',
    day: '项目工作时间'
};
// 定义方法中的名称在excel中的表头的名称  项目表
const projectMapping = {
    name: '项目名称',
    revenue: '营收',
    code: '项目代号',
    manualProportion: '人工占比',
};

const allocationProject = async (date, totalSalary, scientificSalary, project) => {
  // 用在项目上的工时
  const personProjectSalary = getPersonProjectSalary(totalSalary, scientificSalary);
  // 设置项目的人工分摊成本  分配后，再把项目的真实分摊成本写入项目表
  const newProject = setCost(project);
  
  // 分配  一共三张表 部门统计表 分配项目工时 分配项目人工成本
  const department = [];
  const projectTime = [];
  const projectManualCost = [];
  const projectList = []; // 导出的项目表，用来展示真实分摊成本，剩余成本
  
  // 获取月份的节假日信息
  const dateList = await getHolidayAndCalendarInfo(date);
  // 先设置表头
  const departmentHeader = [totalSalaryMapping.name];
  dateList.forEach((item, index) => {
    departmentHeader.push(index + 1);
  });
  department.push(departmentHeader);

  const projectTimeHeader = [totalSalaryMapping.name];
  const projectManualCostHeader = [totalSalaryMapping.name, '月工资'];
  newProject.forEach(item => {
    projectTimeHeader.push(item[projectMapping.code])
    projectManualCostHeader.push(item[projectMapping.code]);
  });
  projectTimeHeader.push('项目天数');
  projectTimeHeader.push('总天数');
  projectTime.push(projectTimeHeader);
  projectManualCost.push(projectManualCostHeader);

  // 目前分配到的项目的索引
  let allocationProjectIndex = 0;
  // 为了确保每个项目都有人，先遍历项目，给每个项目先分配一个人, 如果该人在项目上没有天数，那就跳过分配下一个人
  // 如果项目数量多于人，就再重新分配一次人
  let jumpPersonIndex = 0;
  newProject.forEach((item, index) => {
    const personObj = getCurrentPerson(index, jumpPersonIndex, personProjectSalary);
    jumpPersonIndex = personObj.jumpPersonIndex;
    const person = personObj.currentPerson;

    if (item.remainCost > person.daySalary) {
      item.realCost = add(item.realCost, person.daySalary);
      item.remainCost = subtract(item.remainCost, person.daySalary);
    } else { // 如果项目的分摊成本不够日工资，强行分配一天，并把真实分摊成本写入真实分摊成本列中
      item.realCost = add(item.manualCost, subtract(person.daySalary, item.remainCost));
      item.remainCost = 0;
    }
    if(person.initProject) {
      person.initProject.push(item[projectMapping.code]);
    } else {
      person.initProject = [item[projectMapping.code]];
    }
    person.remainingDay--;
  });
  //当月的工作日天数
  const workDays = dateList.filter(item => item.type === 0).length;
  // 剩余的按项目分配
  personProjectSalary.forEach(item => {
    const departmentRow = [item[totalSalaryMapping.name]];
    // 科研天数，先把科研天数排进去
    let scientificDay = item.scientificDay || 0;
    // 如果项目天数大于工作日天数，算加班处理
    let workOvertimeDay = add(item.projectDay, scientificDay) - workDays;
    dateList.forEach((dateItem) => {
      if (dateItem.type === 0 || workOvertimeDay > 0){ // 工作日
        if (scientificDay > 0) {
          departmentRow.push('非');
          scientificDay--;
        } else { // 分配项目上的成本
          if (item.initProject && item.initProject.length > 0) { //如果有初始分配项目，先从初始项目上分配
            const initCurrent = item.initProject.shift();
            departmentRow.push(initCurrent);
          } else if (item.remainingDay > 0) {
            // 找到分配的项目
            let projectData = getCurrentProject(allocationProjectIndex, newProject);
            allocationProjectIndex = projectData.allocationProjectIndex;
            projectData = projectData.currentProject;
            if (projectData.remainCost > item.daySalary) {
              projectData.realCost = add(projectData.realCost, item.daySalary);
              projectData.remainCost = subtract(projectData.remainCost, item.daySalary);
            } else { // 如果项目的分摊成本不够日工资，强行分配一天，并把真实分摊成本写入真实分摊成本列中
              projectData.realCost = add(projectData.manualCost, subtract(item.daySalary, projectData.remainCost));
              projectData.remainCost = 0;
            }
            departmentRow.push(projectData[projectMapping.code]);
            item.remainingDay--;
          } else {
            departmentRow.push('休');
          }
        }
        if (dateItem.type !== 0) {
          workOvertimeDay--;
        }
      } else { // 节假日
        departmentRow.push('休');
      }
    });
    department.push(departmentRow);
    
    // 统计各个项目的天数
    const countObj = departmentRow.reduce((acc, eve) => {
      acc[eve] = (acc[eve] || 0) + 1;
      return acc;
    }, {});
    
    const projectTimeRow = [item[totalSalaryMapping.name]];
    const projectManualCostRow = [item[totalSalaryMapping.name], round(item.projectSalary)];
    newProject.forEach(pro => {
      const times = countObj[pro[projectMapping.code]] || 0;
      projectTimeRow.push(times);
      projectManualCostRow.push(round(multiply(times, item.daySalary)));
    });
    projectTimeRow.push(item.projectDay);
    projectTimeRow.push(add(item.projectDay, item.scientificDay || 0));
    projectTime.push(projectTimeRow);
    projectManualCost.push(projectManualCostRow);
  });
  // 底部加备注
  addBottomRemark(department, newProject);

  addBottomRemark(projectTime, newProject);

  // 先加统计再加备注
  const statisticsRow = [];
  projectManualCostHeader.forEach((item, index) => {
    if (index === 0) {
      statisticsRow.push('合计');
    } else {
      let total = 0;
      projectManualCost.forEach((row, rowIndex) => {
        if (rowIndex !== 0) {
          total = round(add(total, row[index]));
        }
      });
      statisticsRow.push(total);
    }
  });
  projectManualCost.push(statisticsRow);
  addBottomRemark(projectManualCost, newProject);

  projectList.push([projectMapping.name, projectMapping.revenue, projectMapping.manualProportion, '人工成本', '真实分摊成本', '剩余成本'])
  newProject.forEach(pro => {
    const projectListRow = [pro[projectMapping.name], pro[projectMapping.revenue], pro.manualProportion, pro.manualCost, pro.realCost, pro.remainCost];
    projectList.push(projectListRow);
  });

  return {
    department,
    projectTime,
    projectManualCost,
    project: projectList,
    retainCount: {
      department: personProjectSalary.length + 1,
      projectTime: personProjectSalary.length + 1,
      projectManualCost: personProjectSalary.length + 2,
      project: projectList.length
    },
  };
}


const getCurrentPerson = (index, jumpPersonIndex, personList) => {
  let currentPerson = personList[index + jumpPersonIndex];
  if (!currentPerson) {
    // 项目比人多时，人分配完之后，从0再开始分
    jumpPersonIndex = 0 - index;
    currentPerson = personList[index + jumpPersonIndex];
  }

  if (currentPerson.projectDay > 0) {
    return { currentPerson, jumpPersonIndex};
  } else {
    return getCurrentPerson(index, jumpPersonIndex + 1, personList);
  }
}


const getCurrentProject = (allocationProjectIndex, project) => {
  let currentProject = project[allocationProjectIndex];
  if (!currentProject) {
    throw '项目人工成本不够人员分配';
  }
  if (currentProject.remainCost > 0) {
    return { currentProject, allocationProjectIndex};
  } else {
    return getCurrentProject(allocationProjectIndex + 1, project);
  }
}


// 先获取用在项目上的工时，传入的总工时减去在科研上的工时
const getPersonProjectSalary = (totalSalary, scientificSalary) => {
  const result = totalSalary.map(item => {
    const scientificData = scientificSalary.find(scientificItem => scientificItem[scientificSalaryMapping.name] === item[totalSalaryMapping.name]);
    if (scientificData) {
      item.scientificSalary = scientificData[scientificSalaryMapping.salary];
      item.scientificDay = scientificData[scientificSalaryMapping.day];
      item.projectSalary = subtract(item[totalSalaryMapping.salary], item.scientificSalary);
      item.projectDay = subtract(item[totalSalaryMapping.day], item.scientificDay);
    } else {
      item.projectSalary = item[totalSalaryMapping.salary];
      item.projectDay = item[totalSalaryMapping.day];
    }
    item.remainingDay = item.projectDay;
    item.daySalary = divide(item[totalSalaryMapping.salary], item[totalSalaryMapping.day]); // 日工资
    return item;
  });
  return result;
}

// 获取默认人工成本
const getManualCost = (revenue) => {
  let percent = 0;
  if (revenue > 1000000) {
    percent = 15;
  } else if (revenue > 500000){
    percent = 10;
  } else if (revenue > 100000){
    percent = 8;
  } else if (revenue > 50000) {
    percent = 3;
  } else {
    percent = 2;
  }
  return { manualProportion: percent, manualCost: round(divide(multiply(revenue, percent), 100))};
}

// 设置项目的人工分摊成本
const setCost = (project) => {
  const newProject = [];
  // 项目的人工分摊成本
  for (let i = 0; i < project.length; i++) {
    const item = project[i];
    if (!item[projectMapping.name] || !item[projectMapping.code]) {
      continue;
    }
    const revenue = item[projectMapping.revenue];
    let proportion = item[projectMapping.manualProportion];
    let manualCost = 0;
    if (proportion !== undefined && proportion !== null && typeof proportion === 'number') {
      // if (proportion.indexOf('%') !== -1){
      //   proportion = proportion.replace('%', '');
      // }
      // proportion = Number(proportion);
      manualCost = round(divide(multiply(revenue, proportion), 100));
    } else {
      const cost = getManualCost(revenue);
      proportion = cost.manualProportion;
      manualCost = cost.manualCost;
    }
    
    item.manualProportion = proportion; // 人工占比
    item.manualCost = manualCost; // 人工成本
    item.remainCost = item.manualCost; // 剩余成本
    item.realCost = 0; // 真实分摊成本
    newProject.push(item);
  }
  return newProject;
}

const addBottomRemark = (tableArr, project) => {
  tableArr.push(['备注', '序号', '项目', '项目名称']);
  project.forEach((item, index) => {
    tableArr.push([index === 0 ? '人工分摊' : '', index + 1, item[projectMapping.code], item[projectMapping.name]]);
  });
}

export default allocationProject;